module.exports = __webpack_public_path__ + "img/preload-img-placeholder.d3e8c4f4.svg";